import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://yphmqlkqxlzrruiwqfxz.supabase.co';
const supabaseAnonKey = 'sb_publishable_5yQapShZJJDnX0j2r1de7w_mvGheo8L';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
